module.exports = __webpack_public_path__ + "img/thumbs-up-icon.3e5fde4e.svg";